import { Trans } from '@lingui/react/macro';

import Paragraph from '@/design_system/Typography/Paragraph';
import { BrandRequestMainContent } from '@/layouts/Brand/BrandRequestLayout/BrandRequestLayout';
import { RequestWithRelations } from '@/models/request';
import useViewPort from '@/utils/useViewport';

export const Archived = ({ request }: { request: RequestWithRelations }) => {
  const { isMobile } = useViewPort();

  return (
    <BrandRequestMainContent>
      <Paragraph size={isMobile ? '100' : '50'}>
        {!request.client && (
          <Trans id="store.request.archived.message.store">
            Your care and repair service has been archived.
          </Trans>
        )}
        {!!request.client && (
          <Trans id="store.request.archived.message.client">
            The care and repair service of your client <strong>{request.client.name}</strong> has
            been archived.
          </Trans>
        )}
      </Paragraph>
    </BrandRequestMainContent>
  );
};
